var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0C4.03788 0 0 4.03788 0 9C0 13.9621 4.03788 18 9 18C13.9621 18 18 13.9621 18 9C18 4.03788 13.9621 0 9 0ZM9 14.1429C8.28999 14.1429 7.71429 13.5672 7.71429 12.8571C7.71429 12.147 8.28999 11.5714 9 11.5714C9.71001 11.5714 10.2857 12.147 10.2857 12.8571C10.2857 13.5672 9.71001 14.1429 9 14.1429ZM10.2857 9C10.2857 9.71074 9.71074 10.2857 9 10.2857C8.28926 10.2857 7.71429 9.71074 7.71429 9V5.14286C7.71429 4.43211 8.28926 3.85714 9 3.85714C9.71074 3.85714 10.2857 4.43211 10.2857 5.14286V9Z",
    fill: "#926E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/Alert Icon.0091e3393cbe41a815b9f3a2b0e6679a.svg";
export { ForwardRef as ReactComponent };